/**
 * Registers the service worker. It only exists in a production build —
 * `vite dev` serves modules straight from source with no /sw.js.
 */

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator) || import.meta.env.DEV) {
    return
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // An app that cannot install still has to work online.
    })
  })
}

/** Fires the callback whenever the browser's online state changes. */
export function watchConnection(onChange) {
  window.addEventListener('online', () => onChange(true))
  window.addEventListener('offline', () => onChange(false))

  return navigator.onLine
}
